/**
 * Shows what the charms chosen so far add up to.
 *
 * Picking five small add-ons one at a time makes it easy to lose track of both
 * the count and the cost, which is the moment someone abandons a cart. This
 * reads the personalisation app's own selected state and keeps a running line
 * under the grid: "3 charms added" and the total they add.
 *
 * It attaches only to a group that actually has several image options, so a
 * plain single-select step is left alone.
 */
(() => {
  const MIN_OPTIONS = 3;

  const money = (paise) => {
    const rupees = paise / 100;
    const fixed = Number.isInteger(rupees) ? rupees.toFixed(0) : rupees.toFixed(2);
    return 'Rs. ' + fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /** Pull a price out of a label like "Heart (+ Rs. 30.00)". */
  const priceOf = (label) => {
    const m = label.textContent.match(/([\d,]+(?:\.\d+)?)/);
    if (!m) return 0;
    return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);
  };

  const isPicked = (label) => {
    const input = label.querySelector('input') || document.getElementById(label.htmlFor || '');
    if (input && (input.type === 'checkbox' || input.type === 'radio')) return input.checked;
    return label.classList.contains('active') || label.classList.contains('selected');
  };

  const wire = (group) => {
    const labels = Array.from(group.querySelectorAll('label'));
    if (labels.length < MIN_OPTIONS || !group.querySelector('img')) return;

    const summary = document.createElement('p');
    summary.className = 'charm-summary';
    group.insertAdjacentElement('afterend', summary);

    const render = () => {
      const picked = labels.filter(isPicked);
      const total = picked.reduce((sum, l) => sum + priceOf(l), 0);
      summary.classList.toggle('charm-summary--empty', picked.length === 0);
      summary.innerHTML = picked.length
        ? `<span>${picked.length} ${picked.length === 1 ? 'charm' : 'charms'} added</span>` +
          `<span class="charm-summary__total">+ ${money(total)}</span>`
        : '<span>Tap a charm to add it</span>';
    };

    group.addEventListener('click', () => window.setTimeout(render, 60));
    group.addEventListener('change', render);
    render();
  };

  const start = () => {
    document.querySelectorAll('.gpo-app .gpo-swatches').forEach(wire);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(start, 1200), { once: true });
  } else {
    window.setTimeout(start, 1200);
  }
})();
